import Container from "@client/content/Containers/container";
import TableView from "@client/content/controls/TableView/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { formatMoneyDisplay } from "@client/lib/format";
import { Status } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import InvoiceModal from "./InvoiceModal/container";
import { type MemberOrders } from "./types";

export type MapProps = RootContainerProps & {
  items: MemberOrders.Item[];
  status: string;
};

export interface ActionProps {
  onItemClick: (item: MemberOrders.Item) => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Container {...getContainerProps(props)}>
      <TableView
        {...getRootContainerProps(props)}
        idKey="id"
        isLoading={props.status === Status.Loading}
        columns={[
          { key: "number", name: i18n.order, dataType: "number" },
          { key: "orderDate", name: i18n.date, dataType: "dateTime" },
          { key: "paymentStatusName", name: i18n.payment, dataType: "string" },
          { key: "orderStatusName", name: i18n.processing, dataType: "string" },
          { key: "shippingStatusName", name: i18n.shipping, dataType: "string" },
          { key: "originName", name: i18n.origin, dataType: "string" },
          {
            key: "totalAmount",
            name: i18n.total,
            dataType: "number",
            data: (x) => formatMoneyDisplay(x.totalAmount, x.currencyCode)
          }
        ]}
        data={props.items}
        onRowClick={props.onItemClick}
        itemMenu={null}
      />

      <InvoiceModal {...getRootContainerProps(props)} />
    </Container>
  );
};
